import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';

class ImageView extends Component{

  render(){
    return(
      <Layout {...this.props} type="ImageView"/>
    )
  }
}

ImageView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};

export default ImageView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/ImageView.js